//1. Import
import App from './modules/App';

//2.Initialization
const app=new App();

//3.Event

//4.Function